var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAnnouncementIconinline = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0428 13.8125H9.73249C9.42057 13.8125 9.12143 13.9364 8.90087 14.157C8.68031 14.3775 8.5564 14.6767 8.5564 14.9886V17.7318C8.5564 18.0437 8.68031 18.3428 8.90087 18.5634C9.12143 18.784 9.42057 18.9079 9.73249 18.9079H14.0428V13.8125Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7196 9.70551C23.556 9.59481 23.3672 9.52709 23.1706 9.50859C22.9739 9.49009 22.7758 9.5214 22.5945 9.59964L14.827 13.5661V19.159L22.5914 23.1486C22.9669 23.2641 23.3728 23.226 23.7203 23.0428C23.8786 22.9348 24.008 22.7898 24.0974 22.6204C24.1869 22.4509 24.2335 22.2623 24.2334 22.0707V10.6776C24.2335 10.486 24.1867 10.2972 24.0971 10.1278C24.0075 9.95838 23.8779 9.81341 23.7196 9.70551Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2592 19.6914H11.0925L12.1898 23.5404C12.2598 23.7867 12.4083 24.0035 12.6128 24.1578C12.8173 24.312 13.0665 24.3953 13.3226 24.395H14.0436C14.2226 24.3873 14.3977 24.3401 14.5563 24.2567C14.7149 24.1733 14.8532 24.0559 14.9611 23.9129C15.069 23.7698 15.1439 23.6047 15.1804 23.4292C15.217 23.2538 15.2143 23.0725 15.1725 22.8982L14.2592 19.6914Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0171 15.059V17.6615C25.2457 17.5806 25.4437 17.431 25.5839 17.2331C25.7242 17.0353 25.7999 16.799 25.8006 16.5565V16.164C25.7999 15.9215 25.7242 15.6851 25.5839 15.4873C25.4437 15.2895 25.2457 15.1399 25.0171 15.059Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAnnouncementIconinline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/announcement-icon.inline.f45d1a5991f3e065781da94d5be85fd7.svg";